// proto/v2/chat/chat.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file chat/chat.proto (package lvdr.v2.chat, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { LocalizedCopy, SourceCitation } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { ContextPointer } from "../context/context_pb";
import { file_context_context } from "../context/context_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chat/chat.proto.
 */
export const file_chat_chat: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_common_common, file_context_context]);

/**
 * Requests
 *
 * @generated from message lvdr.v2.chat.CreateChatSessionRequest
 */
export type CreateChatSessionRequest = Message<"lvdr.v2.chat.CreateChatSessionRequest"> & {
  /**
   * @generated from field: lvdr.v2.chat.ChatScope scope = 1;
   */
  scope: ChatScope;

  /**
   * @generated from field: string research_id = 2;
   */
  researchId: string;

  /**
   * HOME-01: the session was opened from the Home idea input; the turn
   * engine adds the intake instruction on its agent-loop turns.
   *
   * @generated from field: bool intake = 3;
   */
  intake: boolean;

  /**
   * MEM-09g: the graph the new chat starts in — "" or "personal" = the personal graph,
   * "ws:<id>" = a mounted Workspace (on its last-used node). The web client sends the
   * graph its Workspace switcher shows; the server validates it like a switch.
   *
   * @generated from field: string context_graph = 4;
   */
  contextGraph: string;

  /**
   * MEM-10: a contexts setup session
   *
   * @generated from field: bool context_setup = 5;
   */
  contextSetup: boolean;
};

/**
 * Describes the message lvdr.v2.chat.CreateChatSessionRequest.
 * Use `create(CreateChatSessionRequestSchema)` to create a new message.
 */
export const CreateChatSessionRequestSchema: GenMessage<CreateChatSessionRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 0);

/**
 * @generated from message lvdr.v2.chat.SendMessageRequest
 */
export type SendMessageRequest = Message<"lvdr.v2.chat.SendMessageRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: optional bool enable_research = 5;
   */
  enableResearch?: boolean | undefined;

  /**
   * @generated from field: optional bool enable_library = 6;
   */
  enableLibrary?: boolean | undefined;

  /**
   * Search across all of the user's research. In research scope, EXCLUDES the
   * current research (which the enable_research chip already controls).
   *
   * @generated from field: optional bool enable_all_research = 7;
   */
  enableAllResearch?: boolean | undefined;

  /**
   * Best-effort snapshot of what the user currently has open on screen, so the
   * assistant can resolve "this report", "the highlighted text", "here", etc.
   * Entirely client-supplied + untrusted; the backend sanitizes before use.
   *
   * @generated from field: lvdr.v2.chat.ViewContext view_context = 8;
   */
  viewContext?: ViewContext | undefined;

  /**
   * Restrict library (uploaded-documents) retrieval to a single document scope.
   * Empty = the full library (subject to enable_library). When set, only
   * documents carrying the scope's effective tags are retrieved. Only meaningful
   * when enable_library is true/unset.
   *
   * @generated from field: string library_scope_id = 9;
   */
  libraryScopeId: string;

  /**
   * Include the user's hand-written notes (KindNoteRef) as a retrieval source,
   * independently of enable_library (which now covers uploaded documents +
   * recordings). Omitted = default ON; explicit false = exclude notes from chat
   * retrieval. Notes still embed/index on save regardless — this gates retrieval
   * only. See docs/plans/2026-06-01-notes-toggle-design.md.
   *
   * @generated from field: optional bool enable_notes = 10;
   */
  enableNotes?: boolean | undefined;

  /**
   * Confidential Compute (2a): when true, this turn runs at the CONFIDENTIAL trust
   * floor — pinned to trusted hardware (Lyceum), fail-closed, billed gpu_private.
   * Grounding is limited to the user's own notes, documents and memory (MEM-11):
   * their query embeds route only to a confidential embedder pinned to the index
   * model, or the search runs keyword-only and the answer carries degraded_reason
   * "confidential_keyword_only". Web search and other workspaces are off.
   * Tier-gated server-side; the FE flag is never trusted. Wire name:
   * confidentialProcessing (TS). Default/omitted = off.
   *
   * @generated from field: optional bool confidential_processing = 11;
   */
  confidentialProcessing?: boolean | undefined;

  /**
   * Quick Search: when true the turn returns a card of raw web-search links
   * (LLM-refined query → SearXNG-only, NO crawl/rerank/synthesis) instead of a
   * grounded answer. Omitted/false = the normal chat pipeline. Gated by
   * LVDR_QUICK_SEARCH_ENABLED; ignored (falls through to normal) when off.
   * Wire name: quickSearch (TS). See docs/plans/2026-06-14-quick-search-design.md.
   *
   * @generated from field: optional bool quick_search = 12;
   */
  quickSearch?: boolean | undefined;

  /**
   * Vision input (2026-07-07): IDs of images the user uploaded via
   * POST /api/v1/chat/attachments and attached to this turn. Each references a
   * per-user encrypted blob; the backend decrypts, caps (≤4, ≤10MB each), and
   * forwards them inline to a sovereign vision model. Empty = a normal text turn.
   * Gated by LVDR_CHAT_VISION_ENABLED. See
   * docs/plans/2026-07-07-chat-vision-input-design.md.
   *
   * @generated from field: repeated string attachment_ids = 13;
   */
  attachmentIds: string[];

  /**
   * Chief of Staff mode (COS-04): when true this chat turn runs the COS persona
   * — a systemPrefix operator overlay + a per-turn COS tool set (task/context
   * read tools always; write/dispatch tools confirmed per the user's cos_autonomy
   * setting). Gated server-side by LVDR_CHIEF_OF_STAFF_ENABLED; the FE flag is
   * never trusted. Omitted/false = the normal chat pipeline. Wire name: cosMode
   * (TS). See docs/plans/2026-07-22-cos04-persona-context-packages-design.md.
   *
   * @generated from field: optional bool cos_mode = 14;
   */
  cosMode?: boolean | undefined;

  /**
   * Effort selector (2026-07-26): the user-chosen reasoning tier for THIS turn,
   * overriding the model's self-triage. UNSPECIFIED/omitted = Auto (self-triage,
   * the default). A hard override, honored server-side ONLY when
   * LVDR_CHAT_THINKING_LEVELS is on AND LVDR_CHAT_EFFORT_SELECTOR is on; otherwise
   * ignored (falls through to self-triage / standard). The FE flag is never
   * trusted. Wire name: requestedTier (TS). See
   * docs/plans/2026-07-26-chat-effort-selector-design.md.
   *
   * @generated from field: lvdr.v2.chat.ThinkingTier requested_tier = 15;
   */
  requestedTier: ThinkingTier;

  /**
   * IANA time-zone name from the browser (CHAT-47), e.g. "Europe/Berlin".
   * Untrusted: at most 64 chars and validated server-side
   * (noteops.ResolveZone); the user's settings zone wins when set.
   *
   * @generated from field: string client_timezone = 16;
   */
  clientTimezone: string;

  /**
   * MEM-09e — any|sovereign|confidential, parsed strictly; this turn only (MEM-09e §4).
   *
   * @generated from field: optional string requested_trust_floor = 17;
   */
  requestedTrustFloor?: string | undefined;

  /**
   * MEM-09e — an assistant message in this session; the server re-runs its
   * stored user message and ignores content.
   *
   * @generated from field: optional string rerun_of_message_id = 18;
   */
  rerunOfMessageId?: string | undefined;
};

/**
 * Describes the message lvdr.v2.chat.SendMessageRequest.
 * Use `create(SendMessageRequestSchema)` to create a new message.
 */
export const SendMessageRequestSchema: GenMessage<SendMessageRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 1);

/**
 * ViewContext is a best-effort, untrusted snapshot of the user's current
 * on-screen state, attached to a chat message so the assistant knows what is
 * open in front of the user. All fields are optional. The voice surface carries
 * the same shape out-of-band (POST /voice/sessions/:id/view) since ElevenLabs,
 * not the browser, drives each voice turn.
 *
 * @generated from message lvdr.v2.chat.ViewContext
 */
export type ViewContext = Message<"lvdr.v2.chat.ViewContext"> & {
  /**
   * Active research-detail tab: result, graph, research-context, dag, diagrams,
   * details, security, journal.
   *
   * @generated from field: string tab = 1;
   */
  tab: string;

  /**
   * @generated from field: string report_title = 2;
   */
  reportTitle: string;

  /**
   * @generated from field: string report_node_id = 3;
   */
  reportNodeId: string;

  /**
   * @generated from field: string document_title = 4;
   */
  documentTitle: string;

  /**
   * @generated from field: string source_url = 5;
   */
  sourceUrl: string;

  /**
   * @generated from field: string source_title = 6;
   */
  sourceTitle: string;

  /**
   * @generated from field: string selected_node_label = 7;
   */
  selectedNodeLabel: string;

  /**
   * @generated from field: string search_query = 8;
   */
  searchQuery: string;

  /**
   * The exact text the user has highlighted on screen, if any.
   *
   * @generated from field: string selected_text = 9;
   */
  selectedText: string;

  /**
   * IDs of the currently-open research / document, so the agentic chat loop can
   * resolve deictic "summarize this" to a concrete entity server-side and load
   * its full content (LVDR_CHAT_AGENT_LOOP). Still untrusted + ownership-checked
   * at tool-execution time — never trust a client-supplied ID. report_node_id is
   * the DAG node; research_id is the research the tools key off.
   *
   * @generated from field: string research_id = 10;
   */
  researchId: string;

  /**
   * @generated from field: string document_id = 11;
   */
  documentId: string;

  /**
   * task_id of the DAG node the user has selected in the graph/dag view, if any.
   * Lets the agentic chat loop resolve deictic "what's this node?" to a concrete
   * research node and load its output via load_research_node. Like the other IDs
   * here it is untrusted + ownership-checked at tool-execution time.
   *
   * @generated from field: string selected_node_task_id = 12;
   */
  selectedNodeTaskId: string;

  /**
   * The note open in the notes editor (CHAT-47). note_id is untrusted and
   * ownership-checked at tool-execution time, exactly like research_id;
   * note_title is rendered into the prompt, note_id is not.
   *
   * @generated from field: string note_id = 13;
   */
  noteId: string;

  /**
   * @generated from field: string note_title = 14;
   */
  noteTitle: string;
};

/**
 * Describes the message lvdr.v2.chat.ViewContext.
 * Use `create(ViewContextSchema)` to create a new message.
 */
export const ViewContextSchema: GenMessage<ViewContext> = /*@__PURE__*/
  messageDesc(file_chat_chat, 2);

/**
 * @generated from message lvdr.v2.chat.GetChatHistoryRequest
 */
export type GetChatHistoryRequest = Message<"lvdr.v2.chat.GetChatHistoryRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor: string;

  /**
   * CTX-02b — the steers this client still waits on. First page only
   * (cursor == ""): the response answers each id in `interjections`.
   * At most 16; a malformed id is ignored.
   *
   * @generated from field: repeated string interject_client_ids = 4;
   */
  interjectClientIds: string[];
};

/**
 * Describes the message lvdr.v2.chat.GetChatHistoryRequest.
 * Use `create(GetChatHistoryRequestSchema)` to create a new message.
 */
export const GetChatHistoryRequestSchema: GenMessage<GetChatHistoryRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 3);

/**
 * @generated from message lvdr.v2.chat.ListChatSessionsRequest
 */
export type ListChatSessionsRequest = Message<"lvdr.v2.chat.ListChatSessionsRequest"> & {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit: number;

  /**
   * @generated from field: lvdr.v2.chat.ChatScope scope = 2;
   */
  scope: ChatScope;
};

/**
 * Describes the message lvdr.v2.chat.ListChatSessionsRequest.
 * Use `create(ListChatSessionsRequestSchema)` to create a new message.
 */
export const ListChatSessionsRequestSchema: GenMessage<ListChatSessionsRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 4);

/**
 * @generated from message lvdr.v2.chat.DeleteChatSessionRequest
 */
export type DeleteChatSessionRequest = Message<"lvdr.v2.chat.DeleteChatSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * MEM-09c: also delete every fact the session wrote (kfx:session:<sid>:).
   *
   * @generated from field: bool forget_facts = 2;
   */
  forgetFacts: boolean;
};

/**
 * Describes the message lvdr.v2.chat.DeleteChatSessionRequest.
 * Use `create(DeleteChatSessionRequestSchema)` to create a new message.
 */
export const DeleteChatSessionRequestSchema: GenMessage<DeleteChatSessionRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 5);

/**
 * @generated from message lvdr.v2.chat.UpdateChatSessionRequest
 */
export type UpdateChatSessionRequest = Message<"lvdr.v2.chat.UpdateChatSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * MEM-09c: optional so a context-only update does not clear the title.
   *
   * @generated from field: optional string title = 2;
   */
  title?: string | undefined;

  /**
   * @generated from field: optional bool pinned = 3;
   */
  pinned?: boolean | undefined;

  /**
   * MEM-09c: set the session's context pointer (a change may fork the session).
   *
   * @generated from field: optional lvdr.v2.context.ContextPointer context = 4;
   */
  context?: ContextPointer | undefined;
};

/**
 * Describes the message lvdr.v2.chat.UpdateChatSessionRequest.
 * Use `create(UpdateChatSessionRequestSchema)` to create a new message.
 */
export const UpdateChatSessionRequestSchema: GenMessage<UpdateChatSessionRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 6);

/**
 * @generated from message lvdr.v2.chat.SubscribeChatSessionRequest
 */
export type SubscribeChatSessionRequest = Message<"lvdr.v2.chat.SubscribeChatSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message lvdr.v2.chat.SubscribeChatSessionRequest.
 * Use `create(SubscribeChatSessionRequestSchema)` to create a new message.
 */
export const SubscribeChatSessionRequestSchema: GenMessage<SubscribeChatSessionRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 7);

/**
 * @generated from message lvdr.v2.chat.UnsubscribeChatSessionRequest
 */
export type UnsubscribeChatSessionRequest = Message<"lvdr.v2.chat.UnsubscribeChatSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message lvdr.v2.chat.UnsubscribeChatSessionRequest.
 * Use `create(UnsubscribeChatSessionRequestSchema)` to create a new message.
 */
export const UnsubscribeChatSessionRequestSchema: GenMessage<UnsubscribeChatSessionRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 8);

/**
 * Responses
 *
 * @generated from message lvdr.v2.chat.ChatSessionResponse
 */
export type ChatSessionResponse = Message<"lvdr.v2.chat.ChatSessionResponse"> & {
  /**
   * @generated from field: lvdr.v2.chat.ChatSession session = 1;
   */
  session?: ChatSession | undefined;

  /**
   * MEM-09c: true when a context change forked a new session.
   *
   * @generated from field: bool forked = 2;
   */
  forked: boolean;
};

/**
 * Describes the message lvdr.v2.chat.ChatSessionResponse.
 * Use `create(ChatSessionResponseSchema)` to create a new message.
 */
export const ChatSessionResponseSchema: GenMessage<ChatSessionResponse> = /*@__PURE__*/
  messageDesc(file_chat_chat, 9);

/**
 * MEM-09c: move a session (and the facts it wrote) to another context node.
 * confirm=false is a preview: moving/staying are counted and nothing is written.
 *
 * @generated from message lvdr.v2.chat.MoveChatSessionContextRequest
 */
export type MoveChatSessionContextRequest = Message<"lvdr.v2.chat.MoveChatSessionContextRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: lvdr.v2.context.ContextPointer context = 2;
   */
  context?: ContextPointer | undefined;

  /**
   * @generated from field: bool confirm = 3;
   */
  confirm: boolean;
};

/**
 * Describes the message lvdr.v2.chat.MoveChatSessionContextRequest.
 * Use `create(MoveChatSessionContextRequestSchema)` to create a new message.
 */
export const MoveChatSessionContextRequestSchema: GenMessage<MoveChatSessionContextRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 10);

/**
 * @generated from message lvdr.v2.chat.MoveChatSessionContextResponse
 */
export type MoveChatSessionContextResponse = Message<"lvdr.v2.chat.MoveChatSessionContextResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: int32 moving = 2;
   */
  moving: number;

  /**
   * @generated from field: int32 staying = 3;
   */
  staying: number;

  /**
   * @generated from field: bool applied = 4;
   */
  applied: boolean;

  /**
   * @generated from field: string error = 5;
   */
  error: string;
};

/**
 * Describes the message lvdr.v2.chat.MoveChatSessionContextResponse.
 * Use `create(MoveChatSessionContextResponseSchema)` to create a new message.
 */
export const MoveChatSessionContextResponseSchema: GenMessage<MoveChatSessionContextResponse> = /*@__PURE__*/
  messageDesc(file_chat_chat, 11);

/**
 * MEM-09c: how many facts the session wrote (the delete dialog's forget count).
 *
 * @generated from message lvdr.v2.chat.CountChatSessionFactsRequest
 */
export type CountChatSessionFactsRequest = Message<"lvdr.v2.chat.CountChatSessionFactsRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message lvdr.v2.chat.CountChatSessionFactsRequest.
 * Use `create(CountChatSessionFactsRequestSchema)` to create a new message.
 */
export const CountChatSessionFactsRequestSchema: GenMessage<CountChatSessionFactsRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 12);

/**
 * @generated from message lvdr.v2.chat.CountChatSessionFactsResponse
 */
export type CountChatSessionFactsResponse = Message<"lvdr.v2.chat.CountChatSessionFactsResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message lvdr.v2.chat.CountChatSessionFactsResponse.
 * Use `create(CountChatSessionFactsResponseSchema)` to create a new message.
 */
export const CountChatSessionFactsResponseSchema: GenMessage<CountChatSessionFactsResponse> = /*@__PURE__*/
  messageDesc(file_chat_chat, 13);

/**
 * MEM-09c: save a chat note as a fact stamped on the session's context.
 *
 * @generated from message lvdr.v2.chat.SaveChatNoteRequest
 */
export type SaveChatNoteRequest = Message<"lvdr.v2.chat.SaveChatNoteRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;
};

/**
 * Describes the message lvdr.v2.chat.SaveChatNoteRequest.
 * Use `create(SaveChatNoteRequestSchema)` to create a new message.
 */
export const SaveChatNoteRequestSchema: GenMessage<SaveChatNoteRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 14);

/**
 * @generated from message lvdr.v2.chat.SaveChatNoteResponse
 */
export type SaveChatNoteResponse = Message<"lvdr.v2.chat.SaveChatNoteResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * MEM-09m: the note went to a Workspace island, which every member can read.
   *
   * @generated from field: bool shared = 3;
   */
  shared: boolean;

  /**
   * The Workspace's member count when shared; absent when not known (never 0 for unknown).
   *
   * @generated from field: optional int32 member_count = 4;
   */
  memberCount?: number | undefined;
};

/**
 * Describes the message lvdr.v2.chat.SaveChatNoteResponse.
 * Use `create(SaveChatNoteResponseSchema)` to create a new message.
 */
export const SaveChatNoteResponseSchema: GenMessage<SaveChatNoteResponse> = /*@__PURE__*/
  messageDesc(file_chat_chat, 15);

/**
 * @generated from message lvdr.v2.chat.ChatSessionListResponse
 */
export type ChatSessionListResponse = Message<"lvdr.v2.chat.ChatSessionListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.chat.ChatSession sessions = 1;
   */
  sessions: ChatSession[];
};

/**
 * Describes the message lvdr.v2.chat.ChatSessionListResponse.
 * Use `create(ChatSessionListResponseSchema)` to create a new message.
 */
export const ChatSessionListResponseSchema: GenMessage<ChatSessionListResponse> = /*@__PURE__*/
  messageDesc(file_chat_chat, 16);

/**
 * @generated from message lvdr.v2.chat.ChatHistoryResponse
 */
export type ChatHistoryResponse = Message<"lvdr.v2.chat.ChatHistoryResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: repeated lvdr.v2.chat.ChatMessage messages = 2;
   */
  messages: ChatMessage[];

  /**
   * @generated from field: string next_cursor = 3;
   */
  nextCursor: string;

  /**
   * The agent audit events of this page's messages (CHAT-47), one per
   * message, so the "actions taken" card and its Undo survive a reload.
   *
   * @generated from field: repeated lvdr.v2.chat.AgentAuditEvent agent_audit = 4;
   */
  agentAudit: AgentAuditEvent[];

  /**
   * CTX-07: the durable write approvals still pending (or just expired) on
   * this page's messages, so the confirm chip re-renders after a reload.
   *
   * @generated from field: repeated lvdr.v2.chat.AgentStepEvent pending_approvals = 5;
   */
  pendingApprovals: AgentStepEvent[];

  /**
   * CTX-02b — the fate of each asked steer, as the InterjectResponse the
   * pushing connection would have received: DELIVERED (its record is on this
   * page), QUEUED (a running turn still holds it) or UNDELIVERED{not_running}.
   * Empty on a cursor page and when nothing was asked.
   *
   * @generated from field: repeated lvdr.v2.chat.InterjectResponse interjections = 6;
   */
  interjections: InterjectResponse[];
};

/**
 * Describes the message lvdr.v2.chat.ChatHistoryResponse.
 * Use `create(ChatHistoryResponseSchema)` to create a new message.
 */
export const ChatHistoryResponseSchema: GenMessage<ChatHistoryResponse> = /*@__PURE__*/
  messageDesc(file_chat_chat, 17);

/**
 * Events
 *
 * @generated from message lvdr.v2.chat.ChatMessageEvent
 */
export type ChatMessageEvent = Message<"lvdr.v2.chat.ChatMessageEvent"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: lvdr.v2.chat.ChatMessage message = 2;
   */
  message?: ChatMessage | undefined;
};

/**
 * Describes the message lvdr.v2.chat.ChatMessageEvent.
 * Use `create(ChatMessageEventSchema)` to create a new message.
 */
export const ChatMessageEventSchema: GenMessage<ChatMessageEvent> = /*@__PURE__*/
  messageDesc(file_chat_chat, 18);

/**
 * @generated from message lvdr.v2.chat.ChatMessageStreamEvent
 */
export type ChatMessageStreamEvent = Message<"lvdr.v2.chat.ChatMessageStreamEvent"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * @generated from field: string chunk = 3;
   */
  chunk: string;

  /**
   * @generated from field: bool is_complete = 4;
   */
  isComplete: boolean;

  /**
   * @generated from field: lvdr.v2.chat.ChatMessage final_message = 5;
   */
  finalMessage?: ChatMessage | undefined;

  /**
   * Pipeline phase: "classifying", "retrieving", "searching_documents", "searching_web", "generating"
   *
   * @generated from field: string phase = 6;
   */
  phase: string;

  /**
   * reasoning_chunk is one incremental delta of the model's chain-of-thought
   * ("thinking"), surfaced live so the user sees progress while the answer is
   * composed. It is NOT answer text — the FE renders it in a separate, collapsible
   * Thinking… affordance and discards it once the answer arrives. Mutually
   * exclusive with `chunk` on a given event.
   *
   * @generated from field: string reasoning_chunk = 7;
   */
  reasoningChunk: string;

  /**
   * follows_message_id, when set, marks this as BACKGROUND thinking — a live
   * reasoning delta from a detached background / think-harder turn that deepens
   * the message with this id. The FE nests it under that parent's "thinking
   * deeper…" affordance (keyed by this id), distinct from the foreground
   * streamingThinking buffer. Empty ⇒ foreground thinking (unchanged).
   *
   * @generated from field: string follows_message_id = 8;
   */
  followsMessageId: string;

  /**
   * replace_content: `chunk` REPLACES the streamed answer so far instead of being
   * appended (it may be empty). Sent when a loop step turned out to be narration
   * before a tool call (CHAT-32). A client that ignores it appends `chunk`.
   *
   * @generated from field: bool replace_content = 9;
   */
  replaceContent: boolean;
};

/**
 * Describes the message lvdr.v2.chat.ChatMessageStreamEvent.
 * Use `create(ChatMessageStreamEventSchema)` to create a new message.
 */
export const ChatMessageStreamEventSchema: GenMessage<ChatMessageStreamEvent> = /*@__PURE__*/
  messageDesc(file_chat_chat, 19);

/**
 * Pushed to every connection of the session owner after the session row is
 * saved (CHAT-53). It is an event, never a reply: a client updates a row it
 * already holds, may add the row for the chat it is already showing, and
 * must never select.
 *
 * @generated from message lvdr.v2.chat.ChatSessionUpdatedEvent
 */
export type ChatSessionUpdatedEvent = Message<"lvdr.v2.chat.ChatSessionUpdatedEvent"> & {
  /**
   * @generated from field: lvdr.v2.chat.ChatSession session = 1;
   */
  session?: ChatSession | undefined;
};

/**
 * Describes the message lvdr.v2.chat.ChatSessionUpdatedEvent.
 * Use `create(ChatSessionUpdatedEventSchema)` to create a new message.
 */
export const ChatSessionUpdatedEventSchema: GenMessage<ChatSessionUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_chat_chat, 20);

/**
 * @generated from message lvdr.v2.chat.ChatSession
 */
export type ChatSession = Message<"lvdr.v2.chat.ChatSession"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: lvdr.v2.chat.ChatScope scope = 4;
   */
  scope: ChatScope;

  /**
   * @generated from field: string research_id = 5;
   */
  researchId: string;

  /**
   * @generated from field: int32 message_count = 6;
   */
  messageCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: bool pinned = 9;
   */
  pinned: boolean;

  /**
   * Stripped-markdown, length-capped preview of the most recent message.
   * Server-populated on list; the gallery uses it for card content.
   *
   * @generated from field: string last_message_preview = 10;
   */
  lastMessagePreview: string;

  /**
   * MEM-09c: the context node the session reads and writes memory in.
   *
   * @generated from field: lvdr.v2.context.ContextPointer context = 11;
   */
  context?: ContextPointer | undefined;
};

/**
 * Describes the message lvdr.v2.chat.ChatSession.
 * Use `create(ChatSessionSchema)` to create a new message.
 */
export const ChatSessionSchema: GenMessage<ChatSession> = /*@__PURE__*/
  messageDesc(file_chat_chat, 21);

/**
 * @generated from message lvdr.v2.chat.ChatMessage
 */
export type ChatMessage = Message<"lvdr.v2.chat.ChatMessage"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: string role = 3;
   */
  role: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 5;
   */
  timestamp?: Timestamp | undefined;

  /**
   * @generated from field: repeated lvdr.v2.common.SourceCitation sources = 7;
   */
  sources: SourceCitation[];

  /**
   * @generated from field: double cost_usd = 8;
   */
  costUsd: number;

  /**
   * @generated from field: int32 tokens_in = 9;
   */
  tokensIn: number;

  /**
   * @generated from field: int32 tokens_out = 10;
   */
  tokensOut: number;

  /**
   * @generated from field: string model_id = 11;
   */
  modelId: string;

  /**
   * @generated from field: lvdr.v2.chat.AnswerMode answer_mode = 12;
   */
  answerMode: AnswerMode;

  /**
   * @generated from field: lvdr.v2.chat.EscalationOffer escalation = 13;
   */
  escalation?: EscalationOffer | undefined;

  /**
   * Per-source provenance flags. True when the answer drew on that source.
   *
   * @generated from field: bool used_research = 14;
   */
  usedResearch: boolean;

  /**
   * @generated from field: bool used_library = 15;
   */
  usedLibrary: boolean;

  /**
   * @generated from field: bool used_web = 16;
   */
  usedWeb: boolean;

  /**
   * @generated from field: bool used_all_research = 17;
   */
  usedAllResearch: boolean;

  /**
   * Per-turn provenance + deterministic-confidence summary produced by the
   * unified turn engine (grounded turn engine, 2026-05-21). Nil on legacy
   * messages persisted before the engine cutover. The frontend gates its
   * display behind NEXT_PUBLIC_TURN_GROUNDING_UI.
   *
   * @generated from field: lvdr.v2.chat.GroundingReport grounding = 18;
   */
  grounding?: GroundingReport | undefined;

  /**
   * ===== Chat thinking-levels depth UI (Phase 1c, 2026-06-03) =====
   * thinking_tier is the depth tier the answer ran at. UNSPECIFIED on
   * legacy/flag-off records. The FE badges only REASONING (gated on
   * chat_thinking_levels). background_pending is true on a foreground partial
   * when a 1b background turn was spawned for it (drives the live "thinking
   * deeper…" indicator). follows_message_id, when set on a background or
   * think-harder follow-up, points at the message it deepens — the FE nests it
   * under that parent and clears the parent's pending indicator.
   *
   * @generated from field: lvdr.v2.chat.ThinkingTier thinking_tier = 19;
   */
  thinkingTier: ThinkingTier;

  /**
   * @generated from field: bool background_pending = 20;
   */
  backgroundPending: boolean;

  /**
   * @generated from field: string follows_message_id = 21;
   */
  followsMessageId: string;

  /**
   * Quick Search metadata (answer_mode == QUICK_SEARCH). Nil on every other
   * message. Carries the original utterance + the LLM-refined query so the FE
   * can render the editable "Searched: <refined>" chip with a fall-back to the
   * user's exact words. The links themselves are in sources[].
   *
   * @generated from field: lvdr.v2.chat.QuickSearchMeta quick_search = 22;
   */
  quickSearch?: QuickSearchMeta | undefined;

  /**
   * Vision input (2026-07-07): images the user attached to this message, echoed
   * back for history re-render. Bytes are NOT inlined here — the FE lazy-loads
   * each from GET /api/v1/chat/attachments/:id (per-user, session-locked). Nil on
   * text-only / legacy messages.
   *
   * @generated from field: repeated lvdr.v2.chat.MessageAttachment attachments = 23;
   */
  attachments: MessageAttachment[];

  /**
   * Retrieval notice (CHAT-43a; widened by LIBSCOPE-01 and MEM-11). True when the
   * document stage OR memory recall (L2) behind this answer did not run as asked:
   * EITHER its search ran BM25-only because the query embed failed or exceeded
   * its cap (see search.HybridSearcher and its queryEmbedTimeout; reason
   * embed_unavailable), OR the user's selected library scope admitted nothing, so
   * the library was not searched at all (reasons scope_empty /
   * scope_unresolvable). confidential_keyword_only: a confidential turn's vector
   * leg did not run on private hardware, so retrieval was keyword-only (MEM-11).
   * This is a PSEUDO-STATUS, not a terminal one: the turn succeeded. Render it as
   * a caveat, never as an error. The field names predate the scope reasons.
   *
   * NOTE the difference from lvdr.v2.dag.DAGNode.degraded_reason, whose field
   * names these copy: DAG's reason is a one-sentence HUMAN string, rendered raw.
   * THIS one is a machine token from a closed set (domain.RagDegradedReasons).
   * A client MUST map it through a lookup with a default -- rendering it raw
   * puts an internal token on a user's screen.
   *
   * Carried here and NOT on ChatMessageStreamEvent on purpose: the terminal
   * stream event sends FinalMessage: messageToProto(msg), the history response
   * sends the same ChatMessage, and the multi-device broadcast envelope is built
   * by the same marshaller -- so one field reaches every surface and they cannot
   * disagree.
   *
   * @generated from field: bool degraded = 24;
   */
  degraded: boolean;

  /**
   * @generated from field: string degraded_reason = 25;
   */
  degradedReason: string;

  /**
   * HELP-03 — true when the answer drew on LumaVista's own product documentation
   * (product_help_search), which is NOT the user's library (used_library).
   *
   * @generated from field: bool used_product_docs = 26;
   */
  usedProductDocs: boolean;

  /**
   * BILL-20f — a plan refusal on this message (chip). Hand-mapped in messageToProto like
   * degraded (24): FinalMessage, history and the multi-device broadcast share that marshaller.
   *
   * @generated from field: lvdr.v2.chat.PlanUpsell plan_upsell = 27;
   */
  planUpsell?: PlanUpsell | undefined;

  /**
   * CTX-29 — tool calls a crash interrupted or that never ran, anchored on this
   * message (chip). A read-time projection of the session log's rp: index, set
   * only on a history read (attachToolOutcomes), not by messageToProto: a live
   * FinalMessage or broadcast carries none, and the chip appears on reload.
   *
   * @generated from field: repeated lvdr.v2.chat.ToolOutcomeNotice tool_outcomes = 28;
   */
  toolOutcomes: ToolOutcomeNotice[];

  /**
   * CTX-02 — the persisted producer of this message: "interjection" for a
   * message the user sent while a turn was running; "" for every ordinary
   * message. Hand-mapped in messageToProto from ChatMessageRecord.Source.
   *
   * @generated from field: string source = 29;
   */
  source: string;

  /**
   * CTX-02b — the client-minted id of the steer this message came from; ""
   * for every other message. The only key a client may match a steer on.
   *
   * @generated from field: string client_id = 30;
   */
  clientId: string;

  /**
   * MEM-09e — hand-mapped in messageToProto; set on the user message of a
   * re-run: the assistant message it re-runs, and the floor it ran at.
   *
   * @generated from field: string rerun_of_message_id = 31;
   */
  rerunOfMessageId: string;

  /**
   * @generated from field: string requested_trust_floor = 32;
   */
  requestedTrustFloor: string;
};

/**
 * Describes the message lvdr.v2.chat.ChatMessage.
 * Use `create(ChatMessageSchema)` to create a new message.
 */
export const ChatMessageSchema: GenMessage<ChatMessage> = /*@__PURE__*/
  messageDesc(file_chat_chat, 22);

/**
 * ToolOutcomeNotice (CTX-29) — one repaired or not-started tool call. outcome is
 * a closed set: "outcome_unknown" | "not_started".
 *
 * @generated from message lvdr.v2.chat.ToolOutcomeNotice
 */
export type ToolOutcomeNotice = Message<"lvdr.v2.chat.ToolOutcomeNotice"> & {
  /**
   * @generated from field: string tool = 1;
   */
  tool: string;

  /**
   * @generated from field: string outcome = 2;
   */
  outcome: string;

  /**
   * @generated from field: int64 at_unix_ms = 3;
   */
  atUnixMs: bigint;
};

/**
 * Describes the message lvdr.v2.chat.ToolOutcomeNotice.
 * Use `create(ToolOutcomeNoticeSchema)` to create a new message.
 */
export const ToolOutcomeNoticeSchema: GenMessage<ToolOutcomeNotice> = /*@__PURE__*/
  messageDesc(file_chat_chat, 23);

/**
 * MessageAttachment is the lightweight, renderable reference to a user-uploaded
 * chat image. It carries no bytes — the FE fetches them from the attachments
 * endpoint. Written on both the inbound echo and persisted history.
 *
 * @generated from message lvdr.v2.chat.MessageAttachment
 */
export type MessageAttachment = Message<"lvdr.v2.chat.MessageAttachment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string mime = 2;
   */
  mime: string;

  /**
   * @generated from field: uint32 width = 3;
   */
  width: number;

  /**
   * @generated from field: uint32 height = 4;
   */
  height: number;
};

/**
 * Describes the message lvdr.v2.chat.MessageAttachment.
 * Use `create(MessageAttachmentSchema)` to create a new message.
 */
export const MessageAttachmentSchema: GenMessage<MessageAttachment> = /*@__PURE__*/
  messageDesc(file_chat_chat, 24);

/**
 * QuickSearchMeta carries the query pair for a Quick Search result card. Both
 * are length-capped server-side before persist (refined_query is LLM output).
 *
 * @generated from message lvdr.v2.chat.QuickSearchMeta
 */
export type QuickSearchMeta = Message<"lvdr.v2.chat.QuickSearchMeta"> & {
  /**
   * @generated from field: string original_query = 1;
   */
  originalQuery: string;

  /**
   * @generated from field: string refined_query = 2;
   */
  refinedQuery: string;
};

/**
 * Describes the message lvdr.v2.chat.QuickSearchMeta.
 * Use `create(QuickSearchMetaSchema)` to create a new message.
 */
export const QuickSearchMetaSchema: GenMessage<QuickSearchMeta> = /*@__PURE__*/
  messageDesc(file_chat_chat, 25);

/**
 * PlanUpsell is the one plan refusal an assistant message carries (BILL-20f, packet D4):
 * a write the user asked for was refused because their plan lacks `feature`. The FE renders
 * the PlanUpsell chip from it. Absent on every other message.
 *
 * @generated from message lvdr.v2.chat.PlanUpsell
 */
export type PlanUpsell = Message<"lvdr.v2.chat.PlanUpsell"> & {
  /**
   * @generated from field: string feature = 1;
   */
  feature: string;

  /**
   * @generated from field: string required_tier = 2;
   */
  requiredTier: string;
};

/**
 * Describes the message lvdr.v2.chat.PlanUpsell.
 * Use `create(PlanUpsellSchema)` to create a new message.
 */
export const PlanUpsellSchema: GenMessage<PlanUpsell> = /*@__PURE__*/
  messageDesc(file_chat_chat, 26);

/**
 * ThinkHarderRequest (Phase 1c) re-runs the turn that produced message_id at one
 * depth tier higher (capped at reasoning), delivering the deeper answer as an
 * appended follow-up (follows_message_id = message_id). Client→server.
 * session_id scopes the per-session message lookup (messages are stored under a
 * per-session Badger prefix, so the server needs it to find message_id and to
 * deliver the follow-up); the client always has it in the open thread.
 *
 * @generated from message lvdr.v2.chat.ThinkHarderRequest
 */
export type ThinkHarderRequest = Message<"lvdr.v2.chat.ThinkHarderRequest"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * Describes the message lvdr.v2.chat.ThinkHarderRequest.
 * Use `create(ThinkHarderRequestSchema)` to create a new message.
 */
export const ThinkHarderRequestSchema: GenMessage<ThinkHarderRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 27);

/**
 * @generated from message lvdr.v2.chat.EscalationOffer
 */
export type EscalationOffer = Message<"lvdr.v2.chat.EscalationOffer"> & {
  /**
   * @generated from field: string suggested_goal = 1;
   */
  suggestedGoal: string;

  /**
   * @generated from field: string suggested_profile = 2;
   */
  suggestedProfile: string;

  /**
   * @generated from field: string reasoning = 3;
   */
  reasoning: string;
};

/**
 * Describes the message lvdr.v2.chat.EscalationOffer.
 * Use `create(EscalationOfferSchema)` to create a new message.
 */
export const EscalationOfferSchema: GenMessage<EscalationOffer> = /*@__PURE__*/
  messageDesc(file_chat_chat, 28);

/**
 * NavigateToSection scrolls the active research view to a named section,
 * optionally highlighting a passage within it.
 *
 * @generated from message lvdr.v2.chat.NavigateToSection
 */
export type NavigateToSection = Message<"lvdr.v2.chat.NavigateToSection"> & {
  /**
   * @generated from field: string section_title = 1;
   */
  sectionTitle: string;

  /**
   * @generated from field: string passage = 2;
   */
  passage: string;
};

/**
 * Describes the message lvdr.v2.chat.NavigateToSection.
 * Use `create(NavigateToSectionSchema)` to create a new message.
 */
export const NavigateToSectionSchema: GenMessage<NavigateToSection> = /*@__PURE__*/
  messageDesc(file_chat_chat, 29);

/**
 * HighlightPassage flashes a passage in the active view.
 *
 * @generated from message lvdr.v2.chat.HighlightPassage
 */
export type HighlightPassage = Message<"lvdr.v2.chat.HighlightPassage"> & {
  /**
   * @generated from field: string passage = 1;
   */
  passage: string;
};

/**
 * Describes the message lvdr.v2.chat.HighlightPassage.
 * Use `create(HighlightPassageSchema)` to create a new message.
 */
export const HighlightPassageSchema: GenMessage<HighlightPassage> = /*@__PURE__*/
  messageDesc(file_chat_chat, 30);

/**
 * SwitchTab switches the active research-detail tab.
 *
 * @generated from message lvdr.v2.chat.SwitchTab
 */
export type SwitchTab = Message<"lvdr.v2.chat.SwitchTab"> & {
  /**
   * @generated from field: string tab = 1;
   */
  tab: string;
};

/**
 * Describes the message lvdr.v2.chat.SwitchTab.
 * Use `create(SwitchTabSchema)` to create a new message.
 */
export const SwitchTabSchema: GenMessage<SwitchTab> = /*@__PURE__*/
  messageDesc(file_chat_chat, 31);

/**
 * ScrollToDiagram scrolls to a diagram by id.
 *
 * @generated from message lvdr.v2.chat.ScrollToDiagram
 */
export type ScrollToDiagram = Message<"lvdr.v2.chat.ScrollToDiagram"> & {
  /**
   * @generated from field: string diagram_id = 1;
   */
  diagramId: string;
};

/**
 * Describes the message lvdr.v2.chat.ScrollToDiagram.
 * Use `create(ScrollToDiagramSchema)` to create a new message.
 */
export const ScrollToDiagramSchema: GenMessage<ScrollToDiagram> = /*@__PURE__*/
  messageDesc(file_chat_chat, 32);

/**
 * OpenSource opens a source (reader / citation card) by stable id.
 *
 * @generated from message lvdr.v2.chat.OpenSource
 */
export type OpenSource = Message<"lvdr.v2.chat.OpenSource"> & {
  /**
   * @generated from field: string source_id = 1;
   */
  sourceId: string;

  /**
   * @generated from field: lvdr.v2.chat.SourceKind kind = 2;
   */
  kind: SourceKind;

  /**
   * @generated from field: string url = 3;
   */
  url: string;
};

/**
 * Describes the message lvdr.v2.chat.OpenSource.
 * Use `create(OpenSourceSchema)` to create a new message.
 */
export const OpenSourceSchema: GenMessage<OpenSource> = /*@__PURE__*/
  messageDesc(file_chat_chat, 33);

/**
 * OpenReportDialog prefills and opens the Generate-report dialog.
 *
 * @generated from message lvdr.v2.chat.OpenReportDialog
 */
export type OpenReportDialog = Message<"lvdr.v2.chat.OpenReportDialog"> & {
  /**
   * @generated from field: string mode = 1;
   */
  mode: string;

  /**
   * @generated from field: string output_form = 2;
   */
  outputForm: string;

  /**
   * @generated from field: string focus = 3;
   */
  focus: string;

  /**
   * @generated from field: string parent_report_id = 4;
   */
  parentReportId: string;
};

/**
 * Describes the message lvdr.v2.chat.OpenReportDialog.
 * Use `create(OpenReportDialogSchema)` to create a new message.
 */
export const OpenReportDialogSchema: GenMessage<OpenReportDialog> = /*@__PURE__*/
  messageDesc(file_chat_chat, 34);

/**
 * NoticeAck surfaces a transient acknowledgement (e.g. "saved",
 * "couldn't find that section").
 *
 * @generated from message lvdr.v2.chat.NoticeAck
 */
export type NoticeAck = Message<"lvdr.v2.chat.NoticeAck"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * info|warning
   *
   * @generated from field: string level = 2;
   */
  level: string;
};

/**
 * Describes the message lvdr.v2.chat.NoticeAck.
 * Use `create(NoticeAckSchema)` to create a new message.
 */
export const NoticeAckSchema: GenMessage<NoticeAck> = /*@__PURE__*/
  messageDesc(file_chat_chat, 35);

/**
 * UIActionEvent is a typed UI directive driven by a turn. The frontend ignores
 * it when research_id does not match the active view.
 *
 * @generated from message lvdr.v2.chat.UIActionEvent
 */
export type UIActionEvent = Message<"lvdr.v2.chat.UIActionEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from oneof lvdr.v2.chat.UIActionEvent.action
   */
  action: {
    /**
     * @generated from field: lvdr.v2.chat.NavigateToSection navigate = 2;
     */
    value: NavigateToSection;
    case: "navigate";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.HighlightPassage highlight = 3;
     */
    value: HighlightPassage;
    case: "highlight";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.SwitchTab switch_tab = 4;
     */
    value: SwitchTab;
    case: "switchTab";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.ScrollToDiagram scroll_diag = 5;
     */
    value: ScrollToDiagram;
    case: "scrollDiag";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.OpenSource open_source = 6;
     */
    value: OpenSource;
    case: "openSource";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.OpenReportDialog open_report = 7;
     */
    value: OpenReportDialog;
    case: "openReport";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.NoticeAck notice = 8;
     */
    value: NoticeAck;
    case: "notice";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message lvdr.v2.chat.UIActionEvent.
 * Use `create(UIActionEventSchema)` to create a new message.
 */
export const UIActionEventSchema: GenMessage<UIActionEvent> = /*@__PURE__*/
  messageDesc(file_chat_chat, 36);

/**
 * EvidenceItem is one retrieved source, with a per-turn 1-based ordinal used in
 * citations ([N]) and the matching evidence card (id="citation-N").
 *
 * @generated from message lvdr.v2.chat.EvidenceItem
 */
export type EvidenceItem = Message<"lvdr.v2.chat.EvidenceItem"> & {
  /**
   * @generated from field: int32 ordinal = 1;
   */
  ordinal: number;

  /**
   * @generated from field: lvdr.v2.chat.SourceKind kind = 2;
   */
  kind: SourceKind;

  /**
   * @generated from field: string source_id = 3;
   */
  sourceId: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string snippet = 5;
   */
  snippet: string;

  /**
   * @generated from field: string url = 6;
   */
  url: string;

  /**
   * reranker relevance
   *
   * @generated from field: double score = 7;
   */
  score: number;

  /**
   * chunkstore reliability
   *
   * @generated from field: double reliability = 8;
   */
  reliability: number;

  /**
   * research_id is the owning research for research / cross-research / report
   * sources; empty for web, library and note sources. It is the CARD's own
   * research, not the route's — EvidenceCards previously inferred the target of
   * its "jump to section" from the URL, which sends a CROSS-research card to
   * whichever research the user happens to be viewing, and is a dead click in
   * library-scope chat where the route carries no id at all.
   *
   * @generated from field: string research_id = 9;
   */
  researchId: string;

  /**
   * research_name mirrors common.SourceCitation.research_name and carries the
   * same three states for the same reason — see that field's comment.
   *
   *   absent          — a record persisted before the field existed; the FE may
   *                     fall back to its title heuristic.
   *   present, empty  — CHAT-13's gate found the research title unsupported by
   *                     its own content and dropped the prefix. Render NO
   *                     research label.
   *   present, set    — render it.
   *
   * Both fields exist here because ChatSourcesPanel — the only consumer of
   * common.SourceCitation.research_name — is SUPPRESSED whenever a
   * GroundingReport is present, and the turn engine attaches one to every
   * assistant message. With turn_grounding_ui on (it is, in every compose) the
   * provenance CHAT-21 added was therefore never reaching a user.
   *
   * @generated from field: optional string research_name = 10;
   */
  researchName?: string | undefined;

  /**
   * area mirrors common.SourceCitation.area (AON-08): "always_on" or absent.
   *
   * @generated from field: optional string area = 11;
   */
  area?: string | undefined;

  /**
   * RET-08: the section of a library document this item cites. section_ids are
   * content-anchored ids of the document's outline, in document order: every
   * deepest section the cited chunk lies in, so one id or each id of a run.
   * section_label is the label as it was when the citation was made
   * ("§ 7.3 Limitation of Liability"); it is stored
   * and never re-derived, so a section that later moves is shown as it was
   * cited. Both are empty for a document-only citation and for an ambiguous one.
   *
   * @generated from field: repeated string section_ids = 12;
   */
  sectionIds: string[];

  /**
   * @generated from field: string section_label = 13;
   */
  sectionLabel: string;

  /**
   * page is the section's page when its source knows one. Absent, not 0, when
   * it does not.
   *
   * @generated from field: optional int32 page = 14;
   */
  page?: number | undefined;

  /**
   * section_state is the state of the section citation. The live turn sets it
   * when the item is cited (RESOLVED, DOCUMENT_ONLY or AMBIGUOUS) and it is
   * persisted with the item. When the history is read, an item that has
   * section_ids gets the state of those sections in the document NOW; that
   * re-check is not saved.
   *
   * @generated from field: lvdr.v2.chat.SectionState section_state = 15;
   */
  sectionState: SectionState;
};

/**
 * Describes the message lvdr.v2.chat.EvidenceItem.
 * Use `create(EvidenceItemSchema)` to create a new message.
 */
export const EvidenceItemSchema: GenMessage<EvidenceItem> = /*@__PURE__*/
  messageDesc(file_chat_chat, 37);

/**
 * SegmentGrounding attributes one span of generated text to evidence.
 *
 * @generated from message lvdr.v2.chat.SegmentGrounding
 */
export type SegmentGrounding = Message<"lvdr.v2.chat.SegmentGrounding"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: lvdr.v2.chat.GroundKind kind = 2;
   */
  kind: GroundKind;

  /**
   * @generated from field: repeated int32 refs = 3;
   */
  refs: number[];

  /**
   * @generated from field: double confidence = 4;
   */
  confidence: number;
};

/**
 * Describes the message lvdr.v2.chat.SegmentGrounding.
 * Use `create(SegmentGroundingSchema)` to create a new message.
 */
export const SegmentGroundingSchema: GenMessage<SegmentGrounding> = /*@__PURE__*/
  messageDesc(file_chat_chat, 38);

/**
 * RedactionSummary is the per-turn, secret-free record of what security
 * filtering withheld. Two layers: sources_filtered = records dropped from the
 * LLM context because they exceeded the outbound sensitivity cap (layer 1);
 * outbound_stripped = secret patterns removed from the generated reply in-flight
 * (layer 2). categories carries labels only (e.g. "SECRET", "api_key") — never
 * the redacted value. Drives the per-turn redaction chip + the AttentionTray flash.
 *
 * @generated from message lvdr.v2.chat.RedactionSummary
 */
export type RedactionSummary = Message<"lvdr.v2.chat.RedactionSummary"> & {
  /**
   * @generated from field: int32 sources_filtered = 1;
   */
  sourcesFiltered: number;

  /**
   * @generated from field: int32 outbound_stripped = 2;
   */
  outboundStripped: number;

  /**
   * @generated from field: repeated string categories = 3;
   */
  categories: string[];
};

/**
 * Describes the message lvdr.v2.chat.RedactionSummary.
 * Use `create(RedactionSummarySchema)` to create a new message.
 */
export const RedactionSummarySchema: GenMessage<RedactionSummary> = /*@__PURE__*/
  messageDesc(file_chat_chat, 39);

/**
 * GroundingReport is the per-turn provenance + confidence summary.
 *
 * @generated from message lvdr.v2.chat.GroundingReport
 */
export type GroundingReport = Message<"lvdr.v2.chat.GroundingReport"> & {
  /**
   * @generated from field: repeated lvdr.v2.chat.EvidenceItem evidence = 1;
   */
  evidence: EvidenceItem[];

  /**
   * @generated from field: repeated lvdr.v2.chat.SegmentGrounding segments = 2;
   */
  segments: SegmentGrounding[];

  /**
   * High|Medium|Low
   *
   * @generated from field: string overall_level = 3;
   */
  overallLevel: string;

  /**
   * @generated from field: bool used_general_knowledge = 4;
   */
  usedGeneralKnowledge: boolean;

  /**
   * secret-free per-turn redaction tally
   *
   * @generated from field: lvdr.v2.chat.RedactionSummary redaction = 5;
   */
  redaction?: RedactionSummary | undefined;

  /**
   * Sensitive-domain advisory: regulated-profession domains detected in the
   * answer (e.g. ["legal","medical"]) and the advisory severity
   * ("standard"|"elevated"|""). Drives the in-app advisory chip. See
   * internal/advisory.
   *
   * @generated from field: repeated string advisory_domains = 6;
   */
  advisoryDomains: string[];

  /**
   * @generated from field: string advisory_severity = 7;
   */
  advisorySeverity: string;

  /**
   * MEM-09e — items withheld this turn because their context is stricter than
   * the turn floor, and the strictest such floor ("sovereign"|"confidential"|"").
   *
   * @generated from field: int32 withheld_count = 8;
   */
  withheldCount: number;

  /**
   * @generated from field: string withheld_floor = 9;
   */
  withheldFloor: string;
};

/**
 * Describes the message lvdr.v2.chat.GroundingReport.
 * Use `create(GroundingReportSchema)` to create a new message.
 */
export const GroundingReportSchema: GenMessage<GroundingReport> = /*@__PURE__*/
  messageDesc(file_chat_chat, 40);

/**
 * ChatRetrievalEvent reports live retrieval activity for a turn stage.
 *
 * @generated from message lvdr.v2.chat.ChatRetrievalEvent
 */
export type ChatRetrievalEvent = Message<"lvdr.v2.chat.ChatRetrievalEvent"> & {
  /**
   * project_knowledge|research_chunks|documents|memory|web
   *
   * @generated from field: string stage = 1;
   */
  stage: string;

  /**
   * started|completed
   *
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string query = 3;
   */
  query: string;

  /**
   * @generated from field: repeated lvdr.v2.chat.EvidenceItem results = 4;
   */
  results: EvidenceItem[];
};

/**
 * Describes the message lvdr.v2.chat.ChatRetrievalEvent.
 * Use `create(ChatRetrievalEventSchema)` to create a new message.
 */
export const ChatRetrievalEventSchema: GenMessage<ChatRetrievalEvent> = /*@__PURE__*/
  messageDesc(file_chat_chat, 41);

/**
 * AgentStepEvent streams one step of the tool-use loop to the client so the
 * "working" trace stays legible (collapsible tool-call list). It is advisory UI
 * telemetry only — never a substitute for the final message. status drives the
 * rendering: running/done for read steps, confirm_needed (mode 1) / plan (mode 2)
 * pause a write behind an interactive chip carrying continuation_id.
 *
 * @generated from message lvdr.v2.chat.AgentStepEvent
 */
export type AgentStepEvent = Message<"lvdr.v2.chat.AgentStepEvent"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * the in-flight assistant message this step belongs to
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * 1-based step index within the turn
   *
   * @generated from field: int32 step = 3;
   */
  step: number;

  /**
   * tool name (e.g. "load_research")
   *
   * @generated from field: string tool = 4;
   */
  tool: string;

  /**
   * "read" | "write"
   *
   * @generated from field: string tool_class = 5;
   */
  toolClass: string;

  /**
   * running | done | failed | confirm_needed | plan
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * tool events: tool identifier + its argument (data, never translated)
   *
   * @generated from field: string title = 7;
   */
  title: string;

  /**
   * legacy literal for an older client; a CURRENT backend leaves it "" for both kinds
   *
   * @generated from field: string detail = 8;
   */
  detail: string;

  /**
   * Set on confirm_needed / plan: the continuation token the client echoes back
   * in ResumeAgentRequest to authorize the pending write(s).
   *
   * @generated from field: string continuation_id = 9;
   */
  continuationId: string;

  /**
   * Pending write preview (confirm_needed) — human line + credit estimate.
   *
   * @generated from field: string preview = 10;
   */
  preview: string;

  /**
   * CREDITS, never currency
   *
   * @generated from field: int64 credits_estimate = 11;
   */
  creditsEstimate: bigint;

  /**
   * kind separates BACKEND PROGRESS narration ("progress") from the agentic loop's
   * TOOL trace (""/"tool"). Empty means "tool" so every event written before this
   * field existed keeps its meaning and its renderer — and so that deleting a
   * `Kind` assignment routes the event to the OTHER branch, which is what makes the
   * progress tests able to fail.
   *
   * @generated from field: string kind = 12;
   */
  kind: string;

  /**
   * CHAT-43c: the localisable form of `title`/`detail`. The client renders these and
   * falls back to the literal above when absent (an older backend). A CURRENT backend
   * leaves `detail` EMPTY for both kinds and `title` EMPTY for progress events —
   * web/messages/*.json is the only English in the system. Progress events key both
   * under chat.turnProgress.; tool events (CHAT-43e) key only detail_copy, under
   * chat.agentTrace., and never set title_copy (their title is data, not copy).
   *
   * @generated from field: lvdr.v2.common.LocalizedCopy title_copy = 13;
   */
  titleCopy?: LocalizedCopy | undefined;

  /**
   * @generated from field: lvdr.v2.common.LocalizedCopy detail_copy = 14;
   */
  detailCopy?: LocalizedCopy | undefined;
};

/**
 * Describes the message lvdr.v2.chat.AgentStepEvent.
 * Use `create(AgentStepEventSchema)` to create a new message.
 */
export const AgentStepEventSchema: GenMessage<AgentStepEvent> = /*@__PURE__*/
  messageDesc(file_chat_chat, 42);

/**
 * AgentAuditEntry is one persisted mutating action taken by the loop.
 *
 * @generated from message lvdr.v2.chat.AgentAuditEntry
 */
export type AgentAuditEntry = Message<"lvdr.v2.chat.AgentAuditEntry"> & {
  /**
   * @generated from field: string audit_id = 1;
   */
  auditId: string;

  /**
   * @generated from field: string tool = 2;
   */
  tool: string;

  /**
   * redacted, human-readable
   *
   * @generated from field: string args_summary = 3;
   */
  argsSummary: string;

  /**
   * CREDITS
   *
   * @generated from field: int64 credits = 4;
   */
  credits: bigint;

  /**
   * did the user explicitly confirm it
   *
   * @generated from field: bool confirmed = 5;
   */
  confirmed: boolean;

  /**
   * confirm | plan | trusted
   *
   * @generated from field: string autonomy_mode = 6;
   */
  autonomyMode: string;

  /**
   * empty => not reversible
   *
   * @generated from field: string undo_token = 7;
   */
  undoToken: string;

  /**
   * applied | failed | undone
   *
   * @generated from field: string status = 8;
   */
  status: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 9;
   */
  timestamp?: Timestamp | undefined;

  /**
   * in-app path ("/notes?id=…"); empty => no link
   *
   * @generated from field: string link = 10;
   */
  link: string;
};

/**
 * Describes the message lvdr.v2.chat.AgentAuditEntry.
 * Use `create(AgentAuditEntrySchema)` to create a new message.
 */
export const AgentAuditEntrySchema: GenMessage<AgentAuditEntry> = /*@__PURE__*/
  messageDesc(file_chat_chat, 43);

/**
 * AgentAuditEvent delivers the audit trail for a turn (the "actions taken" list)
 * so the client can render it with undo/cancel affordances.
 *
 * @generated from message lvdr.v2.chat.AgentAuditEvent
 */
export type AgentAuditEvent = Message<"lvdr.v2.chat.AgentAuditEvent"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * @generated from field: repeated lvdr.v2.chat.AgentAuditEntry entries = 3;
   */
  entries: AgentAuditEntry[];
};

/**
 * Describes the message lvdr.v2.chat.AgentAuditEvent.
 * Use `create(AgentAuditEventSchema)` to create a new message.
 */
export const AgentAuditEventSchema: GenMessage<AgentAuditEvent> = /*@__PURE__*/
  messageDesc(file_chat_chat, 44);

/**
 * ResumeAgentRequest authorizes (or declines) a paused agentic loop. action:
 * confirm = run the pending write(s) and continue; skip = decline the write,
 * continue without it; undo = reverse an already-applied write by undo_token.
 * The resumed loop continues as a NEW assistant message linked via
 * follows_message_id (pause completes the turn; resume is a fresh turn — the
 * billing hold and SessionStore are per-turn). Client→server.
 *
 * @generated from message lvdr.v2.chat.ResumeAgentRequest
 */
export type ResumeAgentRequest = Message<"lvdr.v2.chat.ResumeAgentRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * from AgentStepEvent.continuation_id
   *
   * @generated from field: string continuation_id = 2;
   */
  continuationId: string;

  /**
   * confirm | skip | undo
   *
   * @generated from field: string action = 3;
   */
  action: string;

  /**
   * required when action=undo
   *
   * @generated from field: string undo_token = 4;
   */
  undoToken: string;
};

/**
 * Describes the message lvdr.v2.chat.ResumeAgentRequest.
 * Use `create(ResumeAgentRequestSchema)` to create a new message.
 */
export const ResumeAgentRequestSchema: GenMessage<ResumeAgentRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 45);

/**
 * CTX-02 — a steer sent while the assistant turn turn_message_id is running.
 * turn_message_id is the assistant message id every ChatMessageStreamEvent of
 * that turn carries. client_id is FE-minted; it is echoed on every response.
 * Client→server; answered with InterjectResponse{QUEUED|UNDELIVERED|REJECTED},
 * and for a queued steer also with DELIVERED or UNDELIVERED. Arrival order is
 * NOT guaranteed: the turn can send DELIVERED before the handler's QUEUED
 * reaches the client, and a full send buffer can drop QUEUED. DELIVERED,
 * UNDELIVERED and REJECTED are final; a client must never move a steer from
 * a final status back to QUEUED.
 *
 * @generated from message lvdr.v2.chat.InterjectRequest
 */
export type InterjectRequest = Message<"lvdr.v2.chat.InterjectRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string turn_message_id = 2;
   */
  turnMessageId: string;

  /**
   * @generated from field: string client_id = 3;
   */
  clientId: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;
};

/**
 * Describes the message lvdr.v2.chat.InterjectRequest.
 * Use `create(InterjectRequestSchema)` to create a new message.
 */
export const InterjectRequestSchema: GenMessage<InterjectRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 46);

/**
 * CTX-02 — the fate of one InterjectRequest. reason: for UNDELIVERED a
 * closed set (disabled | not_running | turn_ended | queue_full | turn_limit |
 * save_failed) — the FE resends the text; for REJECTED the ErrorCode name of
 * the refusal (validation, rate limit, filter, quota, ownership) — the FE
 * puts the text back in the composer. The handler never answers a steer with
 * an error envelope, so no global FE error handler fires for one. Exception:
 * the router's subscription gate (BILL-03) runs before the handler and
 * refuses a steer from a lapsed subscription with an error envelope. delivered_message_id
 * (DELIVERED only) is the persisted ChatMessage id the broadcast carries.
 * Server→client.
 *
 * @generated from message lvdr.v2.chat.InterjectResponse
 */
export type InterjectResponse = Message<"lvdr.v2.chat.InterjectResponse"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: lvdr.v2.chat.InterjectResponse.Status status = 2;
   */
  status: InterjectResponse_Status;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: string delivered_message_id = 4;
   */
  deliveredMessageId: string;
};

/**
 * Describes the message lvdr.v2.chat.InterjectResponse.
 * Use `create(InterjectResponseSchema)` to create a new message.
 */
export const InterjectResponseSchema: GenMessage<InterjectResponse> = /*@__PURE__*/
  messageDesc(file_chat_chat, 47);

/**
 * @generated from enum lvdr.v2.chat.InterjectResponse.Status
 */
export enum InterjectResponse_Status {
  /**
   * @generated from enum value: STATUS_UNSPECIFIED = 0;
   */
  STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUEUED = 1;
   */
  QUEUED = 1,

  /**
   * @generated from enum value: DELIVERED = 2;
   */
  DELIVERED = 2,

  /**
   * @generated from enum value: UNDELIVERED = 3;
   */
  UNDELIVERED = 3,

  /**
   * @generated from enum value: REJECTED = 4;
   */
  REJECTED = 4,
}

/**
 * Describes the enum lvdr.v2.chat.InterjectResponse.Status.
 */
export const InterjectResponse_StatusSchema: GenEnum<InterjectResponse_Status> = /*@__PURE__*/
  enumDesc(file_chat_chat, 47, 0);

/**
 * UserMcpPolicy is the per-server governance policy (Spec 4). It travels inside
 * the same encrypted record as the server and is echoed on the wire WITHOUT any
 * secret. All slices empty == DENY (fail-closed, "tools-also-locked").
 *   class ∈ {"notes","research","documents","knowledge"}
 *   blocked_sensitivities use the mesh wire strings ("api_key","password",
 *   "access_token","private_key", …); secrets are always blocked regardless.
 *
 * @generated from message lvdr.v2.chat.UserMcpPolicy
 */
export type UserMcpPolicy = Message<"lvdr.v2.chat.UserMcpPolicy"> & {
  /**
   * exact tool names exposed; empty = none
   *
   * @generated from field: repeated string tool_allowlist = 1;
   */
  toolAllowlist: string[];

  /**
   * "read_only" (default) | "read_write"
   *
   * @generated from field: string mode = 2;
   */
  mode: string;

  /**
   * classes the agent may SEND to this server
   *
   * @generated from field: repeated string send_scopes = 3;
   */
  sendScopes: string[];

  /**
   * classes this server's OUTPUT may write INTO
   *
   * @generated from field: repeated string write_scopes = 4;
   */
  writeScopes: string[];

  /**
   * 4b: outbound-blocked sensitivity classes
   *
   * @generated from field: repeated string blocked_sensitivities = 5;
   */
  blockedSensitivities: string[];
};

/**
 * Describes the message lvdr.v2.chat.UserMcpPolicy.
 * Use `create(UserMcpPolicySchema)` to create a new message.
 */
export const UserMcpPolicySchema: GenMessage<UserMcpPolicy> = /*@__PURE__*/
  messageDesc(file_chat_chat, 48);

/**
 * UserMcpServerInfo is the wire view of one of the user's servers. No secret.
 *
 * @generated from message lvdr.v2.chat.UserMcpServerInfo
 */
export type UserMcpServerInfo = Message<"lvdr.v2.chat.UserMcpServerInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * "none" | "bearer"
   *
   * @generated from field: string auth_type = 4;
   */
  authType: string;

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled: boolean;

  /**
   * a bearer token is stored (never the token)
   *
   * @generated from field: bool has_token = 6;
   */
  hasToken: boolean;

  /**
   * last tools/list error surfaced by a Test (may be empty)
   *
   * @generated from field: string last_error = 7;
   */
  lastError: string;

  /**
   * @generated from field: int64 created_at_unix = 8;
   */
  createdAtUnix: bigint;

  /**
   * Spec 4 governance (no secret); absent => locked default
   *
   * @generated from field: lvdr.v2.chat.UserMcpPolicy policy = 9;
   */
  policy?: UserMcpPolicy | undefined;

  /**
   * OAuth (auth_type="oauth"): status only — tokens/secret NEVER cross the wire.
   * "none" (discovered, ready to connect) | "connected" | "needs_reauth" |
   * "needs_client_config" (DCR unsupported — user must supply client_id/secret).
   *
   * @generated from field: string auth_status = 10;
   */
  authStatus: string;

  /**
   * discovered authorization server (display only; no secret)
   *
   * @generated from field: string oauth_issuer = 11;
   */
  oauthIssuer: string;
};

/**
 * Describes the message lvdr.v2.chat.UserMcpServerInfo.
 * Use `create(UserMcpServerInfoSchema)` to create a new message.
 */
export const UserMcpServerInfoSchema: GenMessage<UserMcpServerInfo> = /*@__PURE__*/
  messageDesc(file_chat_chat, 49);

/**
 * @generated from message lvdr.v2.chat.ListUserMcpServersRequest
 */
export type ListUserMcpServersRequest = Message<"lvdr.v2.chat.ListUserMcpServersRequest"> & {
};

/**
 * Describes the message lvdr.v2.chat.ListUserMcpServersRequest.
 * Use `create(ListUserMcpServersRequestSchema)` to create a new message.
 */
export const ListUserMcpServersRequestSchema: GenMessage<ListUserMcpServersRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 50);

/**
 * @generated from message lvdr.v2.chat.ListUserMcpServersResponse
 */
export type ListUserMcpServersResponse = Message<"lvdr.v2.chat.ListUserMcpServersResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.chat.UserMcpServerInfo servers = 1;
   */
  servers: UserMcpServerInfo[];
};

/**
 * Describes the message lvdr.v2.chat.ListUserMcpServersResponse.
 * Use `create(ListUserMcpServersResponseSchema)` to create a new message.
 */
export const ListUserMcpServersResponseSchema: GenMessage<ListUserMcpServersResponse> = /*@__PURE__*/
  messageDesc(file_chat_chat, 51);

/**
 * @generated from message lvdr.v2.chat.AddUserMcpServerRequest
 */
export type AddUserMcpServerRequest = Message<"lvdr.v2.chat.AddUserMcpServerRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * "none" | "bearer" | "oauth"
   *
   * @generated from field: string auth_type = 3;
   */
  authType: string;

  /**
   * required when auth_type="bearer"
   *
   * @generated from field: string bearer_token = 4;
   */
  bearerToken: string;

  /**
   * Spec 4; absent => locked default (no tools)
   *
   * @generated from field: lvdr.v2.chat.UserMcpPolicy policy = 5;
   */
  policy?: UserMcpPolicy | undefined;

  /**
   * OAuth manual-client fallback (auth_type="oauth"): leave empty for the first
   * attempt (auto Dynamic Client Registration). If add returns
   * auth_status="needs_client_config", resend (or Update) with these populated.
   *
   * @generated from field: string oauth_client_id = 6;
   */
  oauthClientId: string;

  /**
   * optional — public clients (PKCE) omit it
   *
   * @generated from field: string oauth_client_secret = 7;
   */
  oauthClientSecret: string;

  /**
   * optional scope override; empty => discovered scopes
   *
   * @generated from field: repeated string oauth_scopes = 8;
   */
  oauthScopes: string[];
};

/**
 * Describes the message lvdr.v2.chat.AddUserMcpServerRequest.
 * Use `create(AddUserMcpServerRequestSchema)` to create a new message.
 */
export const AddUserMcpServerRequestSchema: GenMessage<AddUserMcpServerRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 52);

/**
 * @generated from message lvdr.v2.chat.AddUserMcpServerResponse
 */
export type AddUserMcpServerResponse = Message<"lvdr.v2.chat.AddUserMcpServerResponse"> & {
  /**
   * @generated from field: lvdr.v2.chat.UserMcpServerInfo server = 1;
   */
  server?: UserMcpServerInfo | undefined;

  /**
   * non-empty => add rejected (validation / cap / SSRF)
   *
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message lvdr.v2.chat.AddUserMcpServerResponse.
 * Use `create(AddUserMcpServerResponseSchema)` to create a new message.
 */
export const AddUserMcpServerResponseSchema: GenMessage<AddUserMcpServerResponse> = /*@__PURE__*/
  messageDesc(file_chat_chat, 53);

/**
 * @generated from message lvdr.v2.chat.UpdateUserMcpServerRequest
 */
export type UpdateUserMcpServerRequest = Message<"lvdr.v2.chat.UpdateUserMcpServerRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * @generated from field: optional bool enabled = 3;
   */
  enabled?: boolean | undefined;

  /**
   * @generated from field: optional string auth_type = 4;
   */
  authType?: string | undefined;

  /**
   * set to rotate; absent => unchanged
   *
   * @generated from field: optional string bearer_token = 5;
   */
  bearerToken?: string | undefined;

  /**
   * set to replace; absent => policy unchanged (no erase)
   *
   * @generated from field: optional lvdr.v2.chat.UserMcpPolicy policy = 6;
   */
  policy?: UserMcpPolicy | undefined;

  /**
   * OAuth (auth_type="oauth"): supply a manual client when DCR is unsupported.
   *
   * @generated from field: optional string oauth_client_id = 7;
   */
  oauthClientId?: string | undefined;

  /**
   * @generated from field: optional string oauth_client_secret = 8;
   */
  oauthClientSecret?: string | undefined;

  /**
   * clear_oauth=true disconnects: wipes stored tokens + client, auth_status => "none".
   *
   * @generated from field: optional bool clear_oauth = 9;
   */
  clearOauth?: boolean | undefined;
};

/**
 * Describes the message lvdr.v2.chat.UpdateUserMcpServerRequest.
 * Use `create(UpdateUserMcpServerRequestSchema)` to create a new message.
 */
export const UpdateUserMcpServerRequestSchema: GenMessage<UpdateUserMcpServerRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 54);

/**
 * @generated from message lvdr.v2.chat.UpdateUserMcpServerResponse
 */
export type UpdateUserMcpServerResponse = Message<"lvdr.v2.chat.UpdateUserMcpServerResponse"> & {
  /**
   * @generated from field: lvdr.v2.chat.UserMcpServerInfo server = 1;
   */
  server?: UserMcpServerInfo | undefined;

  /**
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message lvdr.v2.chat.UpdateUserMcpServerResponse.
 * Use `create(UpdateUserMcpServerResponseSchema)` to create a new message.
 */
export const UpdateUserMcpServerResponseSchema: GenMessage<UpdateUserMcpServerResponse> = /*@__PURE__*/
  messageDesc(file_chat_chat, 55);

/**
 * @generated from message lvdr.v2.chat.RemoveUserMcpServerRequest
 */
export type RemoveUserMcpServerRequest = Message<"lvdr.v2.chat.RemoveUserMcpServerRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message lvdr.v2.chat.RemoveUserMcpServerRequest.
 * Use `create(RemoveUserMcpServerRequestSchema)` to create a new message.
 */
export const RemoveUserMcpServerRequestSchema: GenMessage<RemoveUserMcpServerRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 56);

/**
 * @generated from message lvdr.v2.chat.RemoveUserMcpServerResponse
 */
export type RemoveUserMcpServerResponse = Message<"lvdr.v2.chat.RemoveUserMcpServerResponse"> & {
  /**
   * @generated from field: bool removed = 1;
   */
  removed: boolean;
};

/**
 * Describes the message lvdr.v2.chat.RemoveUserMcpServerResponse.
 * Use `create(RemoveUserMcpServerResponseSchema)` to create a new message.
 */
export const RemoveUserMcpServerResponseSchema: GenMessage<RemoveUserMcpServerResponse> = /*@__PURE__*/
  messageDesc(file_chat_chat, 57);

/**
 * TestUserMcpServerRequest does a live tools/list. If id is set, the stored
 * server is tested; otherwise the supplied url+auth are tested (test-before-add).
 *
 * @generated from message lvdr.v2.chat.TestUserMcpServerRequest
 */
export type TestUserMcpServerRequest = Message<"lvdr.v2.chat.TestUserMcpServerRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string auth_type = 3;
   */
  authType: string;

  /**
   * @generated from field: string bearer_token = 4;
   */
  bearerToken: string;
};

/**
 * Describes the message lvdr.v2.chat.TestUserMcpServerRequest.
 * Use `create(TestUserMcpServerRequestSchema)` to create a new message.
 */
export const TestUserMcpServerRequestSchema: GenMessage<TestUserMcpServerRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 58);

/**
 * @generated from message lvdr.v2.chat.TestUserMcpServerResponse
 */
export type TestUserMcpServerResponse = Message<"lvdr.v2.chat.TestUserMcpServerResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: int32 tool_count = 2;
   */
  toolCount: number;

  /**
   * @generated from field: string error = 3;
   */
  error: string;

  /**
   * the server's tool names — feeds the Spec-4 allowlist editor
   *
   * @generated from field: repeated string tool_names = 4;
   */
  toolNames: string[];
};

/**
 * Describes the message lvdr.v2.chat.TestUserMcpServerResponse.
 * Use `create(TestUserMcpServerResponseSchema)` to create a new message.
 */
export const TestUserMcpServerResponseSchema: GenMessage<TestUserMcpServerResponse> = /*@__PURE__*/
  messageDesc(file_chat_chat, 59);

/**
 * Turn inspector (chat-turn-inspector design rev 2, 2026-10-06). Verbatim,
 * per-user, read from the chat journal. found=false ⇒ no journal turn for this
 * message (evicted, never recorded e.g. voice, or older than the journal).
 *
 * @generated from message lvdr.v2.chat.GetTurnTraceRequest
 */
export type GetTurnTraceRequest = Message<"lvdr.v2.chat.GetTurnTraceRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * the ASSISTANT message id
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;
};

/**
 * Describes the message lvdr.v2.chat.GetTurnTraceRequest.
 * Use `create(GetTurnTraceRequestSchema)` to create a new message.
 */
export const GetTurnTraceRequestSchema: GenMessage<GetTurnTraceRequest> = /*@__PURE__*/
  messageDesc(file_chat_chat, 60);

/**
 * @generated from message lvdr.v2.chat.TurnTraceMessage
 */
export type TurnTraceMessage = Message<"lvdr.v2.chat.TurnTraceMessage"> & {
  /**
   * @generated from field: int32 index = 1;
   */
  index: number;

  /**
   * @generated from field: string role = 2;
   */
  role: string;

  /**
   * set for assembled-prompt blocks; empty for dispatches
   *
   * @generated from field: string block_kind = 3;
   */
  blockKind: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * @generated from field: int32 chars = 5;
   */
  chars: number;
};

/**
 * Describes the message lvdr.v2.chat.TurnTraceMessage.
 * Use `create(TurnTraceMessageSchema)` to create a new message.
 */
export const TurnTraceMessageSchema: GenMessage<TurnTraceMessage> = /*@__PURE__*/
  messageDesc(file_chat_chat, 61);

/**
 * @generated from message lvdr.v2.chat.TurnTraceDispatch
 */
export type TurnTraceDispatch = Message<"lvdr.v2.chat.TurnTraceDispatch"> & {
  /**
   * order of dispatch within the turn
   *
   * @generated from field: int32 seq = 1;
   */
  seq: number;

  /**
   * the model id the request named
   *
   * @generated from field: string model = 2;
   */
  model: string;

  /**
   * @generated from field: repeated lvdr.v2.chat.TurnTraceMessage messages = 3;
   */
  messages: TurnTraceMessage[];

  /**
   * @generated from field: int32 total_chars = 4;
   */
  totalChars: number;

  /**
   * @generated from field: int32 tool_count = 5;
   */
  toolCount: number;

  /**
   * event cap or per-turn budget hit
   *
   * @generated from field: bool truncated = 6;
   */
  truncated: boolean;

  /**
   * "foreground" = the answer's own request; else aux role or "aux"
   *
   * @generated from field: string role = 7;
   */
  role: string;
};

/**
 * Describes the message lvdr.v2.chat.TurnTraceDispatch.
 * Use `create(TurnTraceDispatchSchema)` to create a new message.
 */
export const TurnTraceDispatchSchema: GenMessage<TurnTraceDispatch> = /*@__PURE__*/
  messageDesc(file_chat_chat, 62);

/**
 * @generated from message lvdr.v2.chat.TurnTraceLlmCall
 */
export type TurnTraceLlmCall = Message<"lvdr.v2.chat.TurnTraceLlmCall"> & {
  /**
   * @generated from field: int32 index = 1;
   */
  index: number;

  /**
   * @generated from field: string role = 2;
   */
  role: string;

  /**
   * @generated from field: string model = 3;
   */
  model: string;

  /**
   * @generated from field: int32 prompt_tokens = 4;
   */
  promptTokens: number;

  /**
   * @generated from field: int32 completion_tokens = 5;
   */
  completionTokens: number;

  /**
   * provider cost, NOT user credits (design D5)
   *
   * @generated from field: double cost_usd = 6;
   */
  costUsd: number;

  /**
   * @generated from field: int64 duration_ms = 7;
   */
  durationMs: bigint;

  /**
   * @generated from field: string outcome = 8;
   */
  outcome: string;

  /**
   * @generated from field: string reasoning = 9;
   */
  reasoning: string;

  /**
   * @generated from field: bool reasoning_truncated = 10;
   */
  reasoningTruncated: boolean;

  /**
   * @generated from field: int32 reasoning_chars = 11;
   */
  reasoningChars: number;
};

/**
 * Describes the message lvdr.v2.chat.TurnTraceLlmCall.
 * Use `create(TurnTraceLlmCallSchema)` to create a new message.
 */
export const TurnTraceLlmCallSchema: GenMessage<TurnTraceLlmCall> = /*@__PURE__*/
  messageDesc(file_chat_chat, 63);

/**
 * @generated from message lvdr.v2.chat.TurnTraceToolCall
 */
export type TurnTraceToolCall = Message<"lvdr.v2.chat.TurnTraceToolCall"> & {
  /**
   * @generated from field: int32 step = 1;
   */
  step: number;

  /**
   * @generated from field: string tool = 2;
   */
  tool: string;

  /**
   * @generated from field: string args_json = 3;
   */
  argsJson: string;

  /**
   * CHAT-48: the call's outcome, joined from the journal's agent_tool_result
   * with the same step AND tool (projectTurnTrace). Empty status = no result
   * was journaled for it (a cancelled turn); a consumer must treat "" as
   * not done, never as success.
   *
   * done | failed | confirm_needed | ""
   *
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * read | write (the call's class; the result's when present)
   *
   * @generated from field: string tool_class = 5;
   */
  toolClass: string;

  /**
   * a done write that changed nothing (an existing daily note)
   *
   * @generated from field: bool no_write = 6;
   */
  noWrite: boolean;

  /**
   * How note_id was resolved (CHAT-55): "" = the model's own value, "view" = omitted and
   * defaulted to the open note, "title" = the open note's title, mapped to its id.
   *
   * @generated from field: string note_id_from = 7;
   */
  noteIdFrom: string;
};

/**
 * Describes the message lvdr.v2.chat.TurnTraceToolCall.
 * Use `create(TurnTraceToolCallSchema)` to create a new message.
 */
export const TurnTraceToolCallSchema: GenMessage<TurnTraceToolCall> = /*@__PURE__*/
  messageDesc(file_chat_chat, 64);

/**
 * @generated from message lvdr.v2.chat.GetTurnTraceResponse
 */
export type GetTurnTraceResponse = Message<"lvdr.v2.chat.GetTurnTraceResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * @generated from field: bool found = 3;
   */
  found: boolean;

  /**
   * @generated from field: string turn_id = 4;
   */
  turnId: string;

  /**
   * @generated from field: string requested_model = 5;
   */
  requestedModel: string;

  /**
   * @generated from field: string actual_model = 6;
   */
  actualModel: string;

  /**
   * @generated from field: string finish_reason = 7;
   */
  finishReason: string;

  /**
   * @generated from field: repeated lvdr.v2.chat.TurnTraceDispatch dispatches = 8;
   */
  dispatches: TurnTraceDispatch[];

  /**
   * fallback when dispatches is empty
   *
   * @generated from field: repeated lvdr.v2.chat.TurnTraceMessage assembled_prompt = 9;
   */
  assembledPrompt: TurnTraceMessage[];

  /**
   * @generated from field: repeated lvdr.v2.chat.TurnTraceLlmCall calls = 10;
   */
  calls: TurnTraceLlmCall[];

  /**
   * @generated from field: repeated lvdr.v2.chat.TurnTraceToolCall tools = 11;
   */
  tools: TurnTraceToolCall[];

  /**
   * @generated from field: string final_content = 12;
   */
  finalContent: string;

  /**
   * @generated from field: int64 pre_llm_ms = 13;
   */
  preLlmMs: bigint;

  /**
   * @generated from field: int64 llm_ms = 14;
   */
  llmMs: bigint;

  /**
   * @generated from field: int64 tool_ms = 15;
   */
  toolMs: bigint;

  /**
   * @generated from field: int64 turn_ms = 16;
   */
  turnMs: bigint;

  /**
   * @generated from field: bool truncated = 17;
   */
  truncated: boolean;

  /**
   * @generated from field: string started_at = 18;
   */
  startedAt: string;

  /**
   * CHAT-48: the types of the turn's agent_act directives, in journal order
   * (e.g. "save_note"). Read by the chat-notes eval only (claim backing,
   * journal.ClaimBacking); the inspector does not render it.
   *
   * @generated from field: repeated string act_types = 19;
   */
  actTypes: string[];
};

/**
 * Describes the message lvdr.v2.chat.GetTurnTraceResponse.
 * Use `create(GetTurnTraceResponseSchema)` to create a new message.
 */
export const GetTurnTraceResponseSchema: GenMessage<GetTurnTraceResponse> = /*@__PURE__*/
  messageDesc(file_chat_chat, 65);

/**
 * Domain models
 *
 * @generated from enum lvdr.v2.chat.ChatScope
 */
export enum ChatScope {
  /**
   * @generated from enum value: CHAT_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHAT_SCOPE_PROJECT = 1;
   */
  PROJECT = 1,

  /**
   * @generated from enum value: CHAT_SCOPE_LIBRARY = 2;
   */
  LIBRARY = 2,
}

/**
 * Describes the enum lvdr.v2.chat.ChatScope.
 */
export const ChatScopeSchema: GenEnum<ChatScope> = /*@__PURE__*/
  enumDesc(file_chat_chat, 0);

/**
 * @generated from enum lvdr.v2.chat.AnswerMode
 */
export enum AnswerMode {
  /**
   * @generated from enum value: ANSWER_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ANSWER_MODE_RAG = 1;
   */
  RAG = 1,

  /**
   * @generated from enum value: ANSWER_MODE_WEB_SEARCH = 2;
   */
  WEB_SEARCH = 2,

  /**
   * @generated from enum value: ANSWER_MODE_DIRECT = 3;
   */
  DIRECT = 3,

  /**
   * @generated from enum value: ANSWER_MODE_ESCALATED = 4;
   */
  ESCALATED = 4,

  /**
   * Quick Search: the message carries a card of raw web-search links (no crawl /
   * LLM read). sources[] hold the links; quick_search carries the original +
   * refined query for the editable "Searched:" chip.
   *
   * @generated from enum value: ANSWER_MODE_QUICK_SEARCH = 5;
   */
  QUICK_SEARCH = 5,

  /**
   * The visible answer stream was empty and the message text is the model's
   * SANITISED reasoning channel, surfaced so the turn is not blank. The user is
   * reading marker-stripped chain-of-thought, not a composed answer, and the
   * frontend labels it as such. Additive: unknown values still map to
   * ANSWER_MODE_UNSPECIFIED.
   *
   * @generated from enum value: ANSWER_MODE_REASONING_FALLBACK = 6;
   */
  REASONING_FALLBACK = 6,
}

/**
 * Describes the enum lvdr.v2.chat.AnswerMode.
 */
export const AnswerModeSchema: GenEnum<AnswerMode> = /*@__PURE__*/
  enumDesc(file_chat_chat, 1);

/**
 * ThinkingTier is the depth tier a chat turn ran at (Phase 1a/1c). Mirrors the
 * Go chat.ThinkingTier; an enum (not a bare string) so an unknown wire value
 * decodes to UNSPECIFIED rather than a silent mismatch.
 *
 * @generated from enum lvdr.v2.chat.ThinkingTier
 */
export enum ThinkingTier {
  /**
   * @generated from enum value: THINKING_TIER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: THINKING_TIER_INSTANT = 1;
   */
  INSTANT = 1,

  /**
   * @generated from enum value: THINKING_TIER_STANDARD = 2;
   */
  STANDARD = 2,

  /**
   * @generated from enum value: THINKING_TIER_REASONING = 3;
   */
  REASONING = 3,
}

/**
 * Describes the enum lvdr.v2.chat.ThinkingTier.
 */
export const ThinkingTierSchema: GenEnum<ThinkingTier> = /*@__PURE__*/
  enumDesc(file_chat_chat, 2);

/**
 * SourceKind enumerates the origin of a retrieved evidence item.
 *
 * @generated from enum lvdr.v2.chat.SourceKind
 */
export enum SourceKind {
  /**
   * @generated from enum value: SOURCE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SOURCE_KIND_KNOWLEDGE_NODE = 1;
   */
  KNOWLEDGE_NODE = 1,

  /**
   * @generated from enum value: SOURCE_KIND_RESEARCH_CHUNK = 2;
   */
  RESEARCH_CHUNK = 2,

  /**
   * @generated from enum value: SOURCE_KIND_DOCUMENT = 3;
   */
  DOCUMENT = 3,

  /**
   * @generated from enum value: SOURCE_KIND_WEB_PAGE = 4;
   */
  WEB_PAGE = 4,

  /**
   * @generated from enum value: SOURCE_KIND_MEMORY = 5;
   */
  MEMORY = 5,
}

/**
 * Describes the enum lvdr.v2.chat.SourceKind.
 */
export const SourceKindSchema: GenEnum<SourceKind> = /*@__PURE__*/
  enumDesc(file_chat_chat, 3);

/**
 * GroundKind classifies how a generated segment is supported.
 *
 * @generated from enum lvdr.v2.chat.GroundKind
 */
export enum GroundKind {
  /**
   * @generated from enum value: GROUND_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GROUND_KIND_GROUNDED = 1;
   */
  GROUNDED = 1,

  /**
   * @generated from enum value: GROUND_KIND_GENERAL_KNOWLEDGE = 2;
   */
  GENERAL_KNOWLEDGE = 2,

  /**
   * @generated from enum value: GROUND_KIND_UNCERTAIN = 3;
   */
  UNCERTAIN = 3,
}

/**
 * Describes the enum lvdr.v2.chat.GroundKind.
 */
export const GroundKindSchema: GenEnum<GroundKind> = /*@__PURE__*/
  enumDesc(file_chat_chat, 4);

/**
 * SectionState says whether a stored section citation still names a section.
 *
 * @generated from enum lvdr.v2.chat.SectionState
 */
export enum SectionState {
  /**
   * @generated from enum value: SECTION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The document's current outline holds the section.
   *
   * @generated from enum value: SECTION_STATE_RESOLVED = 1;
   */
  RESOLVED = 1,

  /**
   * The section is no longer in the document (re-converted, renamed, removed).
   *
   * @generated from enum value: SECTION_STATE_DANGLING = 2;
   */
  DANGLING = 2,

  /**
   * More than one section has the cited id.
   *
   * @generated from enum value: SECTION_STATE_AMBIGUOUS = 3;
   */
  AMBIGUOUS = 3,

  /**
   * The citation names the document and no section.
   *
   * @generated from enum value: SECTION_STATE_DOCUMENT_ONLY = 4;
   */
  DOCUMENT_ONLY = 4,

  /**
   * The outline could not be read (the session is locked). Not "dangling".
   *
   * @generated from enum value: SECTION_STATE_UNCHECKED = 5;
   */
  UNCHECKED = 5,
}

/**
 * Describes the enum lvdr.v2.chat.SectionState.
 */
export const SectionStateSchema: GenEnum<SectionState> = /*@__PURE__*/
  enumDesc(file_chat_chat, 5);

